<template>
  <v-container fluid>
    <v-form @submit.prevent="submit"
            :disabled="form.busy"
            class="mb-4">
      <v-card>
        <v-card-title class="pb-0">
          Select Vault Filter
        </v-card-title>
        <v-card-text>
          <v-list>
            <v-radio-group v-model="form.connection"
                           hide-details>
              <template v-for="connection in activeConnections">
                <v-radio :value="connection.id"
                         :label="connection.name">
                  <template v-slot:label>
                    <div>
                      <div class="text-body-1">
                        {{ connection.name }}
                      </div>
                      <div v-if="connection.is_demo === false"
                           class="text-caption">
                        {{ connection.base_uri }}
                      </div>
                    </div>
                  </template>
                </v-radio>
              </template>
            </v-radio-group>
          </v-list>

          <v-switch v-if="currentConnection"
                    v-model="showDetails"
                    label="Show connection details">
          </v-switch>

          <v-img v-if="currentConnection && currentConnection.screenshot_url"
                 :src="currentConnection.screenshot_url"
                 style="border: 1px solid #000000;"
                 max-width="600"
                 contain>
          </v-img>
        </v-card-text>

        <v-card-actions class="px-4">
          <v-btn type="search"
                 color="primary"
                 :disabled="!form.connection">
            Continue
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>

    <template v-if="showDetails && currentConnection">
      <v-card class="mb-4">
        <v-card-title>
          Vault Connection
        </v-card-title>
        <v-card-text>
          <codemirror-json :options="{lineNumbers: true, lineWrapping: true, mode: 'javascript', readOnly: true, theme: 'monokai'}"
                           :code="JSON.stringify(currentConnection, null, 2)"
                           class="mb-4">
          </codemirror-json>
        </v-card-text>
      </v-card>

      <v-card v-if="currentConnection.query"
              class="mb-4">
        <v-card-title>
          Vault Query
        </v-card-title>
        <v-card-text>
          <codemirror-query :options="{lineNumbers: true, lineWrapping: true, mode: 'sql', readOnly: true, theme: 'monokai'}"
                            :code="currentConnection.query">
          </codemirror-query>
        </v-card-text>
      </v-card>

      <v-card v-if="currentConnection.find_query"
              class="mb-4">
        <v-card-title>
          Vault Find Query
        </v-card-title>
        <v-card-text>
          <codemirror-query :options="{lineNumbers: true, lineWrapping: true, mode: 'sql', readOnly: true, theme: 'monokai'}"
                            :code="currentConnection.find_query">
          </codemirror-query>
        </v-card-text>
      </v-card>
    </template>

  </v-container>
</template>
<script>
import {find} from 'lodash';
import {mapGetters} from 'vuex';
import {Form} from 'vform';
import DocumentRow from '../components/DocumentRow';
import VaultImportStepper from './components/Stepper';
import formValidation from '../../../plugins/formValidation';
import CodemirrorJson from '../components/CodeMirrorJson';
import CodemirrorQuery from '../components/CodeMirrorQuery';

export default {
  name: 'vault-import-connection',
  components: {CodemirrorQuery, CodemirrorJson, VaultImportStepper, DocumentRow},
  mixins: [formValidation],
  data() {
    return {
      form: new Form({
        connection: '',
      }),
      showDetails: false,
    }
  },
  computed: {
    ...mapGetters([
      'team',
      'user',
    ]),
    ...mapGetters('veevaVault', [
      'connections',
    ]),
    ...mapGetters('vaultCart', [
      'connection',
      'documents',
      'step',
    ]),
    activeConnections() { // MLD-2958
      return this.connections.filter(c => c.is_active);
    },
    currentConnection() {
      if (this.form.connection) {
        return find(this.connections, c => c.id === this.form.connection);
      }
      return null;
    }
  },
  created() {
    if (this.connection) {
      this.form.connection = this.connection;
    }
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.$store.dispatch('veevaVault/fetchConnections');
    },
    submit() {
      this.$store.dispatch('vaultCart/setConnection', this.form.connection);
      this.$store.dispatch('vaultCart/nextStep');
    },
  }
}
</script>
